<div [ngClass]="nativeScroller ? 'h-full bg-theme-body' : 'h-[100svh] bg-theme-body overflow-hidden'">

  <div class="fixed top-0 left-0 right-0 max-w-lg md:max-w-6xl mx-auto z-10">
    <div class="p-2 md:p-0">

      <div *ngIf="showTopBar && venueName" class="relative bg-theme-surface-80 backdrop-blur-md shadow-sm min-w-32 h-14 flex justify-between w-full rounded-2xl md:rounded-none p-1">

        <app-circle-button *ngIf="!logoBadgeFile" class="w-24" [icon]="'fa-'+venueName.charAt(0).toLowerCase()" size="12" type="solid" fontSize="xl" (onClick)="isKioskMode() ? handleKioskClick() : navHome()"></app-circle-button>
        <app-circle-button *ngIf="logoBadgeFile && logoShape === LogoShape.Circle" [imgUrl]="logoBadgeFile" size="12" type="solid-light-shadow" (onClick)="isKioskMode() ? handleKioskClick() : navHome()" class="w-24 flex justify-start"></app-circle-button>

        <div *ngIf="logoBadgeFile && logoShape === LogoShape.Rectangle" class="w-24 flex items-center flex-shrink-0 md:ml-4">
          <app-base-button baseClass="h-12 min-w-24 flex rounded-l-lg rounded-r-lg items-center justify-start" stateColorScheme="surface" (onClick)="isKioskMode() ? handleKioskClick() : navHome()">
            <img [src]="logoBadgeFile" alt="{{venueName}} logo" class="max-w-full max-h-full object-contain"/>
          </app-base-button>
        </div>

        <div class="absolute left-1/2 transform -translate-x-1/2 max-w-lg md:max-w-6xl ml-2" *ngIf="!isKioskMode()">
          <app-base-button baseClass="h-12 flex rounded-l-lg rounded-r-lg items-center p-4" (onClick)="navTitle()" stateColorScheme="surface">
            <div class="flex flex-col items-start">
              <div class="font-medium text-theme-text text-lg truncate max-w-48 md:max-w-96">{{venueName}}</div>
              <div class="text-theme-text -mt-2 text-lg truncate max-w-48 md:max-w-96" *ngIf="showSubTitle && subTitle">{{ subTitle }}</div>
            </div>
            <div *ngIf="notificationSnapshot && notificationSnapshot?.anyUnread && notificationSnapshot.count>0" class="w-6 h-6 rounded-full flex items-center justify-center text-theme-notification-text font-bold"
                 [ngClass]="{'bg-theme-surface2-strong':!notificationSnapshot.anyUnread, 'bg-theme-notification':notificationSnapshot.anyUnread}">
              {{notificationSnapshot.count}}
            </div>
          </app-base-button>
        </div>

        <!-- Restaurant name in center when in kiosk mode -->
        <div class="absolute left-1/2 transform -translate-x-1/2 max-w-lg md:max-w-6xl ml-2" *ngIf="isKioskMode()">
          <app-base-button baseClass="h-12 flex rounded-l-lg rounded-r-lg items-center p-4"
                           (onClick)="getKioskState() === 'default' ? navFeed() : null"
                           stateColorScheme="surface">
            <div class="flex flex-col items-start">
              <div class="font-medium text-theme-text text-lg truncate max-w-48 md:max-w-96">{{venueName}}</div>
              <!-- Hide table/subtitle info in kiosk mode -->
            </div>
            <!-- Notification badge hidden in kiosk mode -->
          </app-base-button>
        </div>

        <div class="absolute right-1 md:right-4"
             [ngClass]="isKioskMode() && showCallForWaitress ? 'flex items-center gap-2' : 'w-12'">
          <!-- Kiosk call waiter button -->
          <div *ngIf="isKioskMode() && showCallForWaitress"
               class="h-10 px-3 bg-theme-surface rounded-full flex items-center gap-1.5 cursor-pointer hover:bg-theme-surface2 transition-colors shadow-sm"
               (click)="callForWaitress()">
            <i class="fas fa-bell-concierge text-theme-text text-sm"></i>
            <span class="text-theme-text text-xs font-medium">{{ getString('Kalla på servis') }}</span>
          </div>
          <div class="relative">
            <!-- Hamburger menu for kiosk mode -->
            <div *ngIf="isKioskMode()"
                 class="w-12 h-12 bg-theme-surface rounded-full flex items-center justify-center cursor-pointer hover:bg-theme-surface2 transition-colors"
                 (click)="displayKioskMenu()">
              <i class="fas fa-bars text-theme-text text-lg"></i>
            </div>
            <app-circle-button *ngIf="showTopBar && !isKioskMode()" [imgUrl]="(profileInfo$ | async)?.image" [icon]="(isAnon ? 'fa-user' : 'fa-user-check')" size="12" fontSize="xl" type="solid" (onClick)="displayAccountMenu()"></app-circle-button>
            <!-- Translation indicator badge -->
            <div *ngIf="isTranslationActive"
                 class="absolute bottom-0 -left-4 w-8 h-5 bg-theme-surface rounded-full flex items-center justify-center shadow-md pointer-events-none"
                 [ngClass]="{'animate-pulse': isTranslationInProgress}">
              <i class="fas fa-language text-theme-text text-xs"></i>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div [hidden]="!venueName"
       [ngClass]="nativeScroller ? '' : 'overflow-y-auto h-full'"
       #scrollContainer
       appScroll1>
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="!venueName" class="w-screen h-screen flex flex-col items-center justify-center gap-6 px-8">
    <app-loading-spinner></app-loading-spinner>
    @if (loadTimedOut) {
      <div class="text-center text-sm text-theme-text opacity-70">
        <p>Det tar längre tid än vanligt att ladda. Kontrollera din uppkoppling.</p>
        <p>This is taking longer than usual. Please check your connection.</p>
      </div>
      <button type="button" (click)="reloadPage()"
              class="bg-theme-primary text-theme-contrast py-3 px-6 rounded-2xl h-14 min-w-48">
        Försök igen / Try again
      </button>
    }
  </div>

</div>

<div [class.hidden]="isBottomSheetHidden"
     class="fixed inset-0 bg-transparent pointer-events-none z-30 transition-opacity duration-300 text-theme-text">

  <!-- Backdrop - also animated -->
  <div class="absolute inset-0 bg-black pointer-events-auto z-40 transition-opacity duration-300"
       [class.bg-opacity-custom]="isBottomSheetVisible"
       [class.bg-opacity-0]="!isBottomSheetVisible"
       (click)="closeBottomSheet()"
       (wheel)="$event.preventDefault();"
       (touchmove)="$event.preventDefault();">
  </div>

  <!-- Bottom Sheet - pointer-events-auto to allow interaction -->
  <!-- for blur bg-theme-surface-80 backdrop-blur-md -->
  <div class="bottom-0 absolute left-0 right-0
                pointer-events-auto
                transition-transform duration-300 ease-in-out
                flex flex-col max-w-lg
                mx-auto rounded-t-3xl
                min-h-64 max-h-[98dvh]
                bg-theme-surface shadow-xl z-50
                transform translate-y-full"
       [class.translate-y-0]="isBottomSheetVisible"
       [class.translate-y-full]="!isBottomSheetVisible"
  >
    <!-- Sheet Header -->
    <div class="flex mt-8 px-6 pb-4 z-20"
         [class.shadow-lg]="isScrolled"
         (wheel)="$event.preventDefault();" (touchmove)="$event.preventDefault();">
      <div class="text-3xl font-bold break-words w-[calc(100%-3rem)]">{{activeBottomSheetData?.title}}</div>
      <div class="ml-auto" *ngIf="!(activeBottomSheetData?.locked==true)">
        <app-circle-button [icon]="'fa-close'" size="12" type="solid" fontSize="xl" (onClick)="closeBottomSheet()"></app-circle-button>
      </div>
    </div>

    <!-- Sheet Content -->
    <div #sheetContent class="flex-1 overflow-y-auto px-6"
         (wheel)="onScroll($event)"
         (touchstart)="onTouchStart($event)"
         (touchmove)="onScroll($event)">
      <div class="relative" *ngIf="activeBottomSheetData?.item">
        <app-item-detail [item]="activeBottomSheetData!.item!" (onClose)="closeBottomSheet()" [mode]="activeBottomSheetData!.itemMode" [editItem]="activeBottomSheetData!.editItem" [pick]="activeBottomSheetData!.itemMode === 'pick' ? activeBottomSheetData!.sheetData : undefined"></app-item-detail>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='venue-menu'">
        <app-venue-menu></app-venue-menu>
      </div>
      @if (activeBottomSheetData?.sheetClass === 'prebook-invite') {
        <div class="relative">
          <app-prebook-invite-sheet></app-prebook-invite-sheet>
        </div>
      }
      @if (activeBottomSheetData?.sheetClass === 'prebook-menus') {
        <div class="relative">
          <app-prebook-menus-sheet [selectedPageId]="activeBottomSheetData?.sheetData?.selectedPageId"></app-prebook-menus-sheet>
        </div>
      }
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='account-menu'">
        <app-account-menu></app-account-menu>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='loyalty-menu'">
        <app-loyalty-menu></app-loyalty-menu>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='add-loyalty'">
        <app-add-loyalty></app-add-loyalty>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='loyalty-card'">
        <app-loyalty-card [cardData]="activeBottomSheetData?.sheetData"></app-loyalty-card>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='signup-loyalty'">
        <app-signup-loyalty [program]="activeBottomSheetData?.sheetData"></app-signup-loyalty>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='loyalty-agreement'">
        <app-loyalty-agreement></app-loyalty-agreement>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='select-date_time'">
        <app-select-date-time></app-select-date-time>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='prepaid-card'">
        <app-prepaid-card></app-prepaid-card>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='sign-in'">
        <app-sign-in [popCount]="activeBottomSheetData?.sheetData?.popCount"></app-sign-in>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='send-giftcard-email'">
        <app-giftcard-email [sheetData]="activeBottomSheetData!.sheetData"></app-giftcard-email>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='personalized-giftcard'">
        <app-giftcard-personalized-form [sheetData]="activeBottomSheetData!.sheetData"></app-giftcard-personalized-form>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.pushPage">
        <app-push [page]="activeBottomSheetData!.pushPage!" [item]="activeBottomSheetData!.pushPage!.item" [pushIndex]="activeBottomSheetData!.pushPage!.pushIndex" [parentRID]="activeBottomSheetData!.pushPage!.rid"></app-push>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='select-lang'">
        <app-select-lang></app-select-lang>
      </div>
      <div class="relative" *ngIf="activeBottomSheetData?.sheetClass=='push-lang'">
        <app-lang-push></app-lang-push>
      </div>
      @if (activeBottomSheetData?.sheetClass === 'review-detail') {
        <div class="relative">
          <app-review-detail-sheet [sheetData]="activeBottomSheetData?.sheetData"></app-review-detail-sheet>
        </div>
      }
    </div>

  </div>
</div>
